<template>
    <div class="wrapper" style="background-color:#fff;">

        <Sidebar />

        <div class="container " :style="{ 'margin-left': sidebarWidth }">

            <div class="top" style="height:60px;"> </div>

            <h4 class="mb-6 font-semibold">Contract Template</h4>

            <div class="bg-gray-100 min-h-screen flex flex-col  p-4 rounded-xl">

                <div class="row">
                    <div class="col-12 col-md-6" style="margin:4px 0;">
                        <label class="f12">Template Name</label>
                        <input v-model="Tag" class="form-control" placeholder="Name your template" />
                    </div>

                    <div class="col-12 col-md-6" style="margin:4px 0;">

                        <label class="f12" for="contractTypeSelect">Choose Contract Type</label>
                        <div style="display:flex; flex-wrap: wrap;">
                            <div class="form-check" style="width: 50%; display:flex; align-self:center; align-items:center;">
                                <input :disabled="isDisabled" class="form-check-input" type="radio" id="clientContract" value="1" v-model="ContractType" style="float:none; margin-left:0px; margin-top:0px;" @change="updateTerms">
                                <label class="form-check-label" for="clientContract">
                                    Client Contract
                                </label>
                            </div>
                            <div class="form-check" style="width: 50%; display: flex; align-self: center; align-items: center; ">
                                <input :disabled="isDisabled" class="form-check-input" type="radio" id="subcontractorContract" value="0" v-model="ContractType" style="float: none; margin-left: 0px; margin-top: 0px; " @change="updateTerms">
                                <label class="form-check-label" for="subcontractorContract">
                                    Sub-Contractor Contract
                                </label>
                            </div>

                            <div class="form-check" style="width: 50%; display:flex; align-self:center; align-items:center;">
                                <input :disabled="isDisabled" class="form-check-input" type="radio" id="uploadClientContract" value="3" v-model="ContractType" style="float:none; margin-left:0px; margin-top:0px;" @change="updateTerms">
                                <label class="form-check-label" for="uploadClientContract">
                                    Upload Your Own Client Contract
                                </label>
                            </div>

                            <div class="form-check" style="width: 50%; display:flex; align-self:center; align-items:center;">
                                <input :disabled="isDisabled" class="form-check-input" type="radio" id="uploadSubcontractorContract" value="2" v-model="ContractType" style="float:none; margin-left:0px; margin-top:0px;" @change="updateTerms">
                                <label class="form-check-label" for="uploadSubcontractorContract">
                                    Upload Your Own Sub-Contractor Contract
                                </label>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-12">

                    <div class="col-12 text-center" style="font-weight:bold; margin-top:16px; font-size:20px;">
                        {{ TermsTitle }}
                    </div>
                    

                    <div style="font-style:italic;" class="text-center" v-show="ContractType < 2">You may edit these terms or add your own as required.</div>

                    <transition-group name="terms" tag="div">
                        <div class=""
                             v-for="(item, originalIndex) in Terms"
                             :key="item.id"
                             style="margin-top:8px; background-color:white; border-radius:4px; padding:8px; display: flex; ">
                            <!-- Index label -->
                            <div style="margin-right: 8px; font-weight: bold; width: 20px; text-align: center; margin-top: 4px;" v-if="Terms.length > 1">
                                <span v-if="isChecked(item) && Terms.length > 1">
                                    {{ getCheckedIndex(originalIndex) }}.
                                </span>
                                <span v-else>&nbsp;</span> <!-- Render an empty placeholder -->
                            </div>



                            <div style="width: 100%;" class="">
                                <label class="unselectable editable"
                                       v-html="item.value"
                                       v-if="!item.customTerm && Terms.length > 1"
                                       :id="'Editable_' + originalIndex"
                                       contenteditable="true"
                                       unselectable="on"
                                       style="margin-bottom: 5px; width: 100%; padding: 4px; ">
                                </label>

                                <CustomTermWithAI  v-if="item.customTerm && Terms.length > 1"     
                                   
                                          :id="'Editable_' + originalIndex"
                                          :initialText="item.value"
                                          :index="originalIndex"
                                          :originalIndex="originalIndex"
                                          :editable="isChecked(item)"
                                            @showLoader="showLoader"
                                            @hideLoader="hideLoader"
                                             @updateTerm="updateTerm"
                                          />
                                <CustomTermEditorWithAI  v-if="Terms.length == 1 && item.customTerm"              
                                          :id="'Editable_' + originalIndex"
                                          :initialText="item.value"
                                          :index="originalIndex"
                                          :editable="true"
                                          :originalIndex="originalIndex"
                                            @showLoader="showLoader"
                                            @hideLoader="hideLoader"
                                            @updateTerm="updateTerm"
                                          />
 

                                <div class="text-center" style="display:flex; width:100%; position:relative;" v-if="Terms.length > 1">
                                    <div class="toggle-switch" style=" margin: auto;">
                                        <input type="checkbox"
                                               :id="'Terms_' + originalIndex"
                                               v-model="selectedTerms"
                                               :value="item" />

                                        <label :for="'Terms_' + originalIndex"
                                               class="toggle-label"
                                               style="justify-content:center;">
                                            <span class="toggle-indicator" style="width:16px;">Y</span>
                                            <span class="toggle-indicator" style="width:16px;">N</span>
                                        </label>

                                        <label :for="'Terms_' + originalIndex" style="cursor: pointer;">
                                            <span class="toggle-text">Keep Clause</span>
                                        </label>
                                    </div>

                                    <div class="mean"
                                         v-if="VideoUrls[originalIndex] && VideoUrls[originalIndex] != null && VideoUrls[originalIndex].length > 0"
                                         @click="showVideo(VideoUrls[originalIndex])">
                                        <div class="relative thumbnail">
                                            <img :src="getThumbnail(VideoUrls[originalIndex])"
                                                 class="object-cover rounded border w-full h-full hover:shadow-lg"
                                                 alt="video thumbnail" />
                                            <div class="absolute inset-0 flex items-center justify-center text-white hover:text-blue-500 transition-opacity duration-300">
                                                <n-icon size="60">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                        <path d="M10 16.5l6-4.5l-6-4.5zM12 2C6.48 2 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8z" fill="currentColor"></path>
                                                    </svg>
                                                </n-icon>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mean" v-else style="visibility:hidden;">
                                        <span class="material-icons icon material-symbols-outlined">smart_display</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </transition-group>

                    <div class="col-12 btn-bar" >
                        <div class="btn btn-nagative" style="width: 130px;" @click="back">Cancel</div>
                        <div class="btn btn-positive" style="width: 170px;" v-show="showAddTerms" @click="addTerms">Add A New Term</div>
                        <div class="btn btn-positive" style="width: 170px;" @click="saveTemplate(false)">Save Template</div>
                    </div>
                </div>


            </div>

        </div>

        <!-- Video Modal -->
        <n-modal v-model:show="videoModalVisible" style="width: fit-content; max-height: 80vh; text-align:center; position:relative;" preset="card" size="large">
            <video ref="termVideoPlayer"
                   :src="videoSrc"
                   controls
                   style="max-width: 100%; max-height: 70vh; margin:auto;"
                   @ended="onVideoEnd"></video>
        </n-modal>


        <CustomPopup :visible="showPopup"
                     :icon="popupIcon"
                     :iconSrc="popupIconSrc"
                     :iconColor="iconColor"
                     :title="popupTitle"
                     :content="content"
                     :cancelText="cancelText"
                     :confirmText="confirmText"
                     :confirmButtonType="confirmButtonType"
                     :confirmAction="currentConfirmAction"
                     @cancel="onCancel" />

    </div>
</template>

<script>
    import Sidebar from '../components/siderbar/SidebarComponent';
    import { sidebarWidth } from '../components/siderbar/state';
    import CustomPopup from '../components/modals/CustomPopup.vue';
    import CustomTermWithAI from '../components/CustomTermWithAI.vue';
    import CustomTermEditorWithAI from '../components/CustomTermEditorWithAI.vue';

    import { fileUrl, imageUrl } from '../composables/http';

    export default {
        components: {
            Sidebar, CustomPopup, CustomTermWithAI, CustomTermEditorWithAI
        },
        setup() {
            return { sidebarWidth }
        },
        data() {
            return {
                UserId: "",
                sessionId: "",
                ClientTerms: [],
                SubcontractorTerms: [],
                ContractType: 1,
                Tag: "",
                selectedTerms: [], // For keeping track of checked terms
                savedTemplates: [], // To store saved templates
                showTerms: false,
                TermsId: '',

                OriginalClientTerms: [],
                OriginalSubcontractorTerms: [],
                Terms: [],

                VideoUrls: [],

                DefaultClientVideoUrls: [],

                DefaultSubVideoUrls: [],

                isDisabled: false,

                videoModalVisible: false, // Controls modal visibility
                videoSrc: '',             // Holds the current video URL

                nextTermId: 1, // To generate unique IDs

                //Custom Popup

                showPopup: false,
                popupIcon: null, // Set to null since we'll use an image
                popupIconSrc: '', // Use this variable to hold the image path
                iconColor: '',
                popupTitle: '',
                content: '',
                cancelText: '',
                confirmText: '',
                confirmButtonType: 'primary',
                currentConfirmAction: null,

                display : false,

                showAddTerms: true,

                customTermsEditor: "",

                TermsTitle: "Terms of Contract",

            }
        },
        computed: {
            
        },
        mounted() {
            this.sessionId = this.$route.params.sessionid;

            this.UserId = this.$core.data.UserInfo.Id;
             
            if (this.$core.data.SelectedCustomTerms != null) {
                //edit custom terms;
                console.log("SelectedCustomTerms", this.$core.data.SelectedCustomTerms);
                

                this.Tag = this.$core.data.SelectedCustomTerms.Tag;
                this.TermsId = this.$core.data.SelectedCustomTerms.Id;
               // this.selectedTerms = this.$core.data.SelectedCustomTerms.Terms;
                this.OriginalClientTerms = this.$core.data.SelectedCustomTerms.Terms;
                this.OriginalSubcontractorTerms = this.$core.data.SelectedCustomTerms.Terms;



                this.ClientTerms = this.$core.data.SelectedCustomTerms.Terms;
                this.SubcontractorTerms = this.$core.data.SelectedCustomTerms.Terms;

                //this.Terms = this.$core.data.SelectedCustomTerms.Terms;

                this.ContractType = this.$core.data.SelectedCustomTerms.Type;
                if(this.$core.data.SelectedCustomTerms.Terms.length == 1){
                    this.ContractType += 2;
                }

                //console.log("Terms", this.Terms);

                this.isDisabled = true;

                let customTerms = this.$core.data.SelectedCustomTerms.Terms.length == 1? true : false;
                this.$core.data.SelectedCustomTerms.Terms.forEach((item, idx) => {
                    
                    this.Terms.push({ id: idx + 1, value: item, customTerm: customTerms });
                    this.selectedTerms.push({ id: idx + 1, value: item, customTerm: customTerms  });

                    this.nextTermId = idx + 1;
                });

               
            } else {
               
                //this.getSubcontractorTerms();
                this.getClientTerms();
            }
             
        },
        methods: {



            updateTerm(index, value){
                //console.log("updateTerm", index, value);

                this.Terms[index].value = value;

                this.selectedTerms[index].value = value;

               // console.log("selectedTerms", this.selectedTerms);
            },


            showLoader(){
                this.$loader.show(null, 30);
            },
            hideLoader(){
                this.$loader.hide();
            },

            isChecked(term) {
                 
                return this.selectedTerms.some(existingTerm => existingTerm.id === term.id);
            },
            getCheckedIndex(originalIndex) {
                // Filter Terms to calculate the index of the checked item
                return (
                    this.Terms.slice(0, originalIndex + 1).filter((term) =>
                        this.selectedTerms.some(existingTerm => existingTerm.id === term.id)
                    ).length
                );
            },
            getThumbnail(url) {
                //const match = url.match(/([^/]+)(?=\.\w+$)/);
                const match = url.match(/([^/]+?)(?:\.\w+)?$/);
                return imageUrl(match ? match[1] : '', 120,90);
            },
            showVideo(videoUrl) {
                this.videoSrc = videoUrl; // Set the video source
                this.videoModalVisible = true; // Show the modal

                this.$nextTick(() => {
                    // Automatically play the video once the modal is opened
                    this.$refs.termVideoPlayer.play();
                });
            },
            onVideoEnd() {
                // Optionally handle the event when the video ends
                console.log("Video has ended");
            },

            updateTerms() {

                this.TermsTitle = "Terms of Contract";
                this.showAddTerms = true;
                let _this = this;
                if (this.ContractType == 1) {
                    //this.selectedTerms = [];
                    //this.Terms = [];

                    setTimeout(() => {
                        //this.Terms = [..._this.ClientTerms];

                        this.Terms = JSON.parse(JSON.stringify(_this.ClientTerms));
                        this.selectedTerms =  JSON.parse(JSON.stringify(_this.ClientTerms));

                        this.VideoUrls = [..._this.DefaultClientVideoUrls];

                        this.nextTermId = this.Terms.length + 1;
                    }, 100); // Delay to allow animation to start
                 
                
                
                } else if(this.ContractType == 0){

                    setTimeout(() => {
                        this.Terms = JSON.parse(JSON.stringify(_this.SubcontractorTerms));
                        this.selectedTerms = JSON.parse(JSON.stringify(_this.SubcontractorTerms));

                        //this.Terms = [..._this.SubcontractorTerms];
                        //this.selectedTerms = [..._this.SubcontractorTerms];
                        this.VideoUrls = [..._this.DefaultSubVideoUrls];

                        this.nextTermId = this.Terms.length + 1;
                    }, 100); // Delay to allow animation to start

                    //this.selectedTerms = [];
                    //this.Terms = [];
                   
                   
                }else{

                    if(this.ContractType == 3){
                        this.TermsTitle = "Upload your own Client contract here"
                    }else{
                        this.TermsTitle = "Upload your own Sub-Contractor contract here"
                    }

                    this.showAddTerms = false;
                    setTimeout(() => {
                        this.Terms = [{ id: 1, value: '', customTerm: true }];
                        this.selectedTerms =  [{ id: 1, value: '', customTerm: true }];
                        this.VideoUrls =  [""];

                        this.nextTermId = this.Terms.length + 1;
                    }, 100); // Delay to allow animation to start
                }
  
            },
            createTemplate() {

             
                this.Tag = ''; // Clear the tag input after saving
                this.ContractType = 1;   
               
                this.TermsId = "";

                //reset terms...
                this.ClientTerms = [...this.OriginalClientTerms]; 
                this.SubcontractorTerms = [...this.OriginalSubcontractorTerms];  
               

                this.Terms = JSON.parse(JSON.stringify(this.OriginalClientTerms));
                this.selectedTerms =  JSON.parse(JSON.stringify(this.OriginalClientTerms));
             
                //this.Terms = [...this.OriginalClientTerms];
                //this.selectedTerms = [...this.OriginalClientTerms];

                //this.selectedTerms = this.Terms;

                this.VideoUrls = [...this.DefaultClientVideoUrls];

                this.nextTermId = this.Terms.length + 1;
                 
            },
            back() {
                this.$router.back();
            },
            addTerms() {

                this.nextTermId++;

                this.selectedTerms.push({ id: this.nextTermId, value: "", customTerm: true });
                this.Terms.push({ id: this.nextTermId, value: "", customTerm: true });

                //this.updateTerms();
 
            },

            templateSaved() {

                let _this = this;
                this.showPopup = true;


                //this.popupIcon = 'FieldTimeOutlined';
                this.iconColor = 'red';
                this.popupIconSrc = null; // Replace with your image path
                this.popupTitle = "Contract Template Saved!";
                this.content = "";
                this.cancelText = null;
                this.confirmText = 'OK';
                this.confirmButtonType = 'success';
                this.currentConfirmAction = () => {
                    _this.$router.back();
                };
            },

            alertAndSave() {

                this.iconColor = 'red';
                this.popupIconSrc = null // Replace with your image path
                this.popupTitle = 'Terms Changed';

                this.content = 'Your edits for this custom Contract template will take effect for any new agreements you make. These edits will not impact or change any previous agreements you made using this template.';
                this.cancelText = null;
                this.confirmText = 'OK';
                    
                this.confirmButtonType = 'success';
                this.currentConfirmAction = () => this.saveTemplate(true);
                this.showPopup = true;

                this.autoClose = false;

                
            },

            saveTemplate(checked = false) {

                if (this.Tag.length === 0 || this.Tag === 'Default Contract Template') {
                    //this.$ui.alert(this, "Please enter a name for your template", "", null);

                    this.showPopup = true;


                    //this.popupIcon = 'FieldTimeOutlined';
                    this.iconColor = 'red';
                    this.popupIconSrc = require('@/assets/images/icons/InfoIcon.png'); // Replace with your image path
                    this.popupTitle = "";
                    this.content = "Please enter a name for your template";
                    this.cancelText = null;
                    this.confirmText = 'OK';
                    this.confirmButtonType = 'success';
                    this.currentConfirmAction = null;

                    return;
                }

                //console.log("Terms", this.Terms);
                //console.log("Terms 0", this.Terms[0].value);

                //console.log("Selected Terms", this.selectedTerms);

                var newTerms = [];

                if(this.ContractType > 1){//for custom Terms...
                    newTerms.push(this.Terms[0].value);
                }else{
                    var elts = document.getElementsByClassName("editable");
                
                    for (var i = 0; i < elts.length; i++) {

                        let el = document.getElementById("Terms_" + i);
                        if(el && el.checked){
                            if (elts[i].innerHTML.length > 0)
                                newTerms.push(elts[i].innerHTML);
                        }
                         
                    }
                }
                 

                let type = this.ContractType > 1 ? this.ContractType - 2: this.ContractType;

                
                console.log("newTerms", newTerms);
                if(newTerms.length === 0){
                    return ;
                }

                if(!checked && this.$core.data.SelectedCustomTerms && this.$core.data.SelectedCustomTerms.UsageCount > 0 ){
                    this.alertAndSave();
                    return;
                }

                let _this = this;
                if (this.TermsId.length === 0) {
                    const data = {
                        Tag: this.Tag,
                        Type: type ,
                        Terms: newTerms,
                        UserId: this.UserId
                    };
                    //console.log("template", data);

                    this.$http.request("post", "/api/app/customterm/create", data).then((res) => {
                        //console.log("Add CustomTerms", _data);

                        if (res?.Type == 200) {
                            _this.templateSaved();

                        }else{
                            this.alertMessage(res?.Content);
                        }
                    });
                } else {

                    const data = {
                        Id: this.TermsId,
                        Tag: this.Tag,
                        Type: type  ,
                        Terms: newTerms,
                        UserId: this.UserId
                    };
                    //console.log("eidt template", data);

                    this.$http.request("put", "/api/app/customterm/update", data).then((res) => {
                        //console.log("Edit CustomTerms", _data);

                        if (res?.Type == 200) {

                            _this.templateSaved();
                            
                        }else{
                            this.alertMessage(res?.Content);
                        }
                    });

                }
               
            },
 
            getSubcontractorTerms() {
                this.$http.request("get","/api/app/term/readlist?type=1").then((res) => {
                    if (res?.Type == 200) {
                        for (var i = 0; i < res.Data.length; i++) {
                            this.SubcontractorTerms.push({ id: i + 1, value: res.Data[i].Text, customTerm: false });

                            this.OriginalSubcontractorTerms.push({ id: i + 1, value: res.Data[i].Text, customTerm: false });


                            if (res.Data[i].Video == null || res.Data[i].Video.length == 0) {

                                this.DefaultSubVideoUrls.push(res.Data[i].Video);
                            } else {
                                //this.VideoUrls.push(`https://contractly.ca/api/cloud/files/${res.Data[i].Video}`);

                                
                                this.DefaultSubVideoUrls.push(fileUrl(res.Data[i].Video));
                            }

                            this.nextTermId = i + 1;
                        }
                        this.createTemplate();
                    }
                });
            },

            getClientTerms() {
                this.$http.request("get", "/api/app/term/readlist?type=0").then((res) => {
                    if (res?.Type == 200) {

                        for (var i = 0; i < res.Data.length; i++) {
                            this.ClientTerms.push({ id: i + 1, value: res.Data[i].Text, customTerm: false });

                            this.OriginalClientTerms.push({ id: i + 1, value: res.Data[i].Text, customTerm: false });


                            if (res.Data[i].Video == null || res.Data[i].Video.length == 0) {
                                this.VideoUrls.push(res.Data[i].Video);
                                this.DefaultClientVideoUrls.push(res.Data[i].Video);
                            } else {
                                this.VideoUrls.push(fileUrl(res.Data[i].Video));
                                this.DefaultClientVideoUrls.push(fileUrl(res.Data[i].Video));
                            }

                            this.nextTermId = i + 1;
                        }

                      
                        this.getSubcontractorTerms();
                    }
                });
            },

            alertMessage(msg) {              

               //this.popupIcon = 'FieldTimeOutlined';
               this.iconColor = 'red';
               this.popupIconSrc = null // Replace with your image path
               this.popupTitle = msg;
               this.content = null;
               this.cancelText = null;
               this.confirmText = 'OK';
               this.confirmButtonType = 'success';
               this.currentConfirmAction = null;
               this.showPopup = true;

                this.autoClose = false;

           },

            onCancel() {
                this.showPopup = false;
                this.currentConfirmAction = null;
            }
        }
    };
</script>

<style scoped>


    .toggle-switch {
        display: flex;
        align-items: center;
        background-color: #f5f7f6;
        padding: 0 8px 0 8px;
        border-radius: 2px;
        color: #38a169;
        font-size: 14px;
    }

    input[type="checkbox"] {
        display: none;
    }

    .toggle-indicator {
        color: white;
    }

    .toggle-label {
        width: 40px;
        font-size: 12px;
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        padding: 2px 4px;
        background-color: #ccc; /* Light background color */

        border-radius: 15px;
        position: relative;
        font-weight: bold;
        color: #38a169; /* Green color */
        transition: background-color 0.3s;
    }

        .toggle-label::before {
            content: ' ';
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #e6f9f0; /* Toggle color */
            color: #fff;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            position: absolute;
            left: 2px;
            transition: transform 0.3s;
        }

    input[type="checkbox"]:checked + .toggle-label::before {
        transform: translateX(20px); /* Shift toggle position when checked */
    }

    input[type="checkbox"]:checked + .toggle-label {
        background-color: #38a169; /* Light green background when checked */
    }

    .toggle-text {
        margin-left: 8px; /* Space for the toggle circle */
        font-weight: bold;
    }

    .terms-enter-active, .terms-leave-active {
        transition: all 0.5s ease;
    }

    .terms-enter, .terms-leave-to /* .terms-leave-active in <2.1.8 */ {
        opacity: 0;
        transform: translateY(20px);
    }

    .terms-move {
        transition: transform 0.5s ease;
    }

    /* Custom styling */
    .container-fix {
     
        border-radius: 8px;
        min-height:100vh;
    }

    .terms-bg{background-color:white; border-radius:15px; margin-top:40px;}
    .content {
        display: flex;
        flex-wrap: wrap;
    }
    /* Container holding the templates */
    .templates-container {
        display: flex;
        width: 100%; /* Responsive grid */
        gap: 16px;
        padding: 16px;
        border: 1px solid gray;
        border-radius: 5px;
        margin: 16px 0px;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: stretch; /* Ensures all cards stretch to the same height */
    }

    /* Individual card styles */
    .template-card {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background-color: #f9f9f9;
        border-radius: 8px;
        padding: 8px;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);      
        min-width: 240px;
        min-height: 150px; /* Ensures a minimum height */
        color: white;
        cursor: pointer;
    }

       
    /* Title of the template */
    .template-title {
        font-size: 1.0em;
        display: flex;
        margin-top: 24px;
        margin-bottom: 8px;
    }

    /* Contract type tag */
    .template-type {
        font-size: 0.7em;       
        border-radius: 4px;
        display: flex;
        align-items:center;
    }

    /* Card colors based on contract type */
    .template-card.client {
        background: linear-gradient(to bottom, #2196f3, #0d47a1); /* Light to dark blue */
    }

    .template-card.sub-contractor {
        background: linear-gradient(to bottom, #ff9800, #e65100); /* Light to dark orange */
    }

    .template-card.default {
        background: linear-gradient(to bottom, #4caf50, #357a38); /* Light to dark green */
    }

    /* Menu icon (three dots) */
    .template-menu {
        position: absolute;
        top: 8px;
        right: 8px;
        cursor: pointer;
    }
     
    .contract-box {
        min-height: 300px;
        background-color: aliceblue;
    }
    .contract-box .header{
        color:white;
        background-color:#132338;
        padding: 4px 16px;
    }
    .title{font-weight:bold; font-size:20px !important; margin: 16px 0; padding:0px;}

    .closeBtn{background-color:black; color:white; border-radius:50%; width:30px; height:30px; cursor:pointer; text-align:center;}
    .terms-container {
        border: 1px solid #ccc;
        border-radius: 10px;
        background-color: #fdeddc;
        padding: 4px;
        margin: 8px 0;
    }
   
    .form-check .form-check-input {
        float: right;
        margin-left: -1.5em;
    }

    .form-check-label {
        padding: 4px;
         
        margin-right: 20px !important;
        width: calc(100% - 40px);
    }

    .form-check {
        padding-left: .5em;
        padding-right: 0px !important;
        width: 100%;
    }

    .info {
        font-size: 12px;
        color: black;
        text-align: center;
    }

    .container-fix {
        max-width: 1080px;
    }

    .title {
        font-size: 14px;
    }

    .form-check-label.editable {
        cursor: text;
    }

    .mt-3 {
        margin-top: 1rem;
    }

    .mt-4 {
        margin-top: 1.5rem;
    }

    .terms-enter-active, .terms-leave-active {
        transition: all 0.5s ease;
    }

    .terms-enter, .terms-leave-to /* .terms-leave-active in <2.1.8 */ {
        opacity: 0;
        transform: translateY(20px);
    }

    .terms-move {
        transition: transform 0.5s ease;
    }
</style>
